import { jsx as _jsx } from "react/jsx-runtime";
import { closestCenter, DndContext, MeasuringStrategy, PointerSensor, useSensor, useSensors, } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, } from '@dnd-kit/sortable';
import { useTreeState } from './hooks/use-tree-state.js';
import { useDragAndDrop } from './hooks/use-drag-and-drop.js';
const MEASURING_CONFIG = {
    droppable: { strategy: MeasuringStrategy.Always },
};
export const DnDNavTree = ({ items, activeNavItem, children, onItemsChange, isDraggable = false, }) => {
    const treeState = useTreeState({
        activeItemId: activeNavItem.id,
        items,
    });
    const dragAndDropState = useDragAndDrop({
        items,
        onItemsChange,
        expandedItems: treeState.expandedItems,
    });
    const sensors = useSensors(useSensor(PointerSensor, {
        activationConstraint: {
            delay: 150,
            tolerance: 5,
        },
    }));
    return (_jsx(DndContext, { sensors: sensors, collisionDetection: closestCenter, measuring: MEASURING_CONFIG, ...dragAndDropState.handlers, children: _jsx(SortableContext, { items: dragAndDropState.sortableIds, strategy: verticalListSortingStrategy, disabled: !isDraggable, children: children({
                isDragging: !!dragAndDropState.dragState.activeId,
                flattenedItems: dragAndDropState.flattenedItems,
                treeState: {
                    isItemExpanded: treeState.isItemExpanded,
                    isItemActive: treeState.isItemActive,
                    toggleExpanded: treeState.toggleExpanded,
                },
            }) }) }));
};
